export default "__VITE_ASSET__f9ba3f7d__"